const Tooltip = ({ children, content, placement = "bottom" }) => {
  return (
    <div
      className={`hs-tooltip [--placement: ${placement}] inline-block`}
      role="tooltip"
      aria-label={content}
    >
      <div
        className={`hs-tooltip-toggle hover:scale-110 transition-transform duration-200 ease-in-out`}
      >
        {children}
        <span
          className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded-lg shadow-sm  "
          role="tooltip"
        >
          {content}
        </span>
      </div>
    </div>
  );
};

export default Tooltip;
